export default "__VITE_ASSET__Cw$1qEd9__"